module.exports = __webpack_public_path__ + "img/1.6.1813dc3a.png";